export default __webpack_public_path__ + "static/media/theE.d60e204a.webp";